<div class="container single-view" id="view-survey">
  <div class="row">
    <div class="col-12 mb-4 flex flex-wrap items-end justify-between gap-4">
      <div id="pre-header-wr">
        <a data-testid="back-btn" href="javascript:void(0)" appBack fallbackUrl="/surveys" class="inline-flex items-center text-base link link-icon left-arrow">{{ 'SURVEYS.BTN_BACK_TO_SURVEYS' | translate }}</a>
      </div>
      <div class="switch-wr">
        @if (allowModifySurvey) {
          <p-selectButton
            class="status-switch"
            [class.status-active]="stateInitialValue === true"
            [options]="stateOptions"
            optionLabel="displayLabel"
            optionValue="value"
            [allowEmpty]="false"
            [(ngModel)]="stateInitialValue"
            (onChange)="onStateChange($event)">
            <ng-template #item let-option>
              <span
                class="status-option"
                [attr.data-testid]="'btn-' + option.label">
                <i class="pi pi-check status-check" aria-hidden="true"></i>
                <span>{{ option.displayLabel }}</span>
              </span>
            </ng-template>
          </p-selectButton>
        }
      </div>
    </div>

    <div class="col-12">
      <div id="view-header-wr" class="flex flex-wrap items-end justify-between gap-4">

        <div class="title-wr flex flex-wrap items-center">
          <div data-testid="survey-item">
            <h1 data-testid="section-item" class="section-title mb-3">{{ 'SURVEYS_SINGLE_VIEW.SURVEY_DETAILS' | translate }}</h1>
            <div>
              <h2 data-testid="element-item" class="element-title flex items-center gap-2">
                @if (survey?.name) {
                  <span data-testid="survey-name">{{ survey?.name | defaultValue }}</span>
                }
                @if (survey?.isActive) {
                  <span class="tag tag-green" data-testid="survey-active-status">{{ 'ENUMS.ACTIVE' | translate }}</span>
                }
                @if (!survey?.isActive) {
                  <span class="tag tag-red" data-testid="survey-active-status">{{ 'ENUMS.INACTIVE' | translate }}</span>
                }
                @if (survey?.isPublished) {
                  <span class="tag tag-green" data-testid="survey-publication-status">{{ 'ENUMS.PUBLISHED' | translate }}</span>
                }
                @if (!survey?.isPublished) {
                  <span class="tag tag-red" data-testid="survey-publication-status">{{ 'ENUMS.UNPUBLISHED' | translate }}</span>
                }
              </h2>
            </div>
          </div>
        </div>
        <div class="flex flex-wrap justify-between gap-y-4 self-end">
          <div id="complementary-details" class="flex flex-col"></div>
          <div id="actions-wr" class="flex flex-wrap items-stretch justify-end gap-3">
            @if (allowModifySurvey) {
              <button data-testid="survey-take-btn" class="btn outline-btn" type="button" [disabled]="!survey?.isPublished" (click)="takeSurvey()">{{ 'SURVEYS_SINGLE_VIEW.BTN_TAKE_SURVEY' | translate }}</button>
            }
            @if (allowModifySurvey) {
              <button data-testid="survey-edit-btn" class="btn primary-btn" type="button" [disabled]="survey?.isPublished" (click)="goToEditSurvey()">{{ 'SURVEYS_SINGLE_VIEW.BTN_EDIT' | translate }}</button>
            }
            @if (delete) {
              <button data-testid="survey-delete-btn" class="btn red-btn" (click)="dialog?.show()">{{ 'SURVEYS_SINGLE_VIEW.BTN_DELETE' | translate }}</button>
            }
          </div>
        </div>

        @if (showPublishNotice && allowModifySurvey && survey && !survey.isPublished) {
          <app-notice
            type="blue"
            icon="warning-icon"
            dataTestId="survey-publish-notice"
            [message]="'SURVEYS_SINGLE_VIEW.PUBLISH_NOTICE' | translate"
            [dismissible]="true"
            [dismissLabel]="'SURVEYS_SINGLE_VIEW.CANCEL' | translate"
            [confirmLabel]="'SURVEYS_SINGLE_VIEW.BTN_CONFIRM_PUBLISH' | translate"
            [confirmDisabled]="isPublishing"
            (onDismissed)="cancelPublishNotice()"
            (onConfirmed)="publishSurvey()">
          </app-notice>
        }
      </div>

      <hr role="presentation" class="w-full mb-3 mt-4 border-t">

      <div class="view-content-wr">
        <div class="row">
          <div class="flex flex-col col-12 mb-2 text-wr">
            @if (survey) {
              <section class="row">
                <div class="col-12">
                  <h4>{{ 'SURVEYS_SINGLE_VIEW.DETAILS' | translate }}</h4>
                  <hr role="presentation" class="w-full mb-2 mt-3 border-t">
                  <dl class="details-grid">
                    <dt class="label grid-cols-1 pt-3">{{ 'SURVEYS_SINGLE_VIEW.NAME' | translate }}</dt>
                    <dd class="value pt-3 pb-3">{{ survey.name | defaultValue }}</dd>
                    <dt class="label grid-cols-1 pt-3">{{ 'SURVEYS_SINGLE_VIEW.QUESTIONS_COUNT' | translate }}</dt>
                    <dd class="value pt-3 pb-3">{{ survey.questions?.length ?? 0 }}</dd>
                  </dl>
                </div>
              </section>
            }

            @if (survey?.questions?.length) {
              <section class="row mt-5">
                <div class="col-12 mb-3">
                  <h4>{{ 'SURVEYS_SINGLE_VIEW.QUESTIONS' | translate }}</h4>
                  <hr role="presentation" class="w-full mb-2 mt-3 border-t">
                </div>
                <div class="questions-wr col-12 flex flex-col gap-4" data-testid="survey-questions">
                  @for (question of survey?.questions; track question; let i = $index) {
                    <div class="rounded-lg border overflow-hidden">
                      <!-- Question header -->
                      <div class="question-header-wr flex flex-wrap items-center justify-between gap-3 px-3 py-2">
                        <div class="flex items-center gap-3">
                          <span class="inline-flex items-center justify-center text-xs font-semibold shrink-0">
                            #{{ i + 1 }}
                          </span>
                          <span class="font-semibold text-sm">{{ question.code | defaultValue }}</span>
                        </div>
                        <div class="flex flex-wrap items-center gap-2">
                          @if (question.questionType) {
                            <span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium tag">
                              {{ question.questionType | questionTypePipe }}
                            </span>
                          }
                          @if (question.allowsMultipleAnswers) {
                            <span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium tag">
                              {{ 'SURVEYS_SINGLE_VIEW.ALLOWS_MULTIPLE_ANSWERS' | translate }}
                            </span>
                          }
                        </div>
                      </div>
                      <!-- Question body -->
                      <div class="question-body-grid" [class.question-body-grid--two-columns]="question.answerOptions?.length">
                        <div class="question-translation-wr">
                          <p class="text-xs font-semibold uppercase mb-2">{{ 'SURVEYS_SINGLE_VIEW.QUESTION_TRANSLATIONS' | translate }}</p>
                          @if (question.questionTranslations?.length) {
                            @for (translation of question.questionTranslations; track translation; let isLast = $last) {
                              <div class="flex items-start gap-2 py-1.5" [class.border-b]="!isLast">
                                <span class="inline-flex items-center px-1.5 py-0.5 rounded text-xs font-semibold shrink-0 mt-0.5">
                                  {{ translation.isoCode | languagePipe }}
                                </span>
                                <span class="text-sm">{{ translation.translation | defaultValue }}</span>
                              </div>
                            }
                          } @else {
                            <span class="text-sm">{{ null | defaultValue }}</span>
                          }
                        </div>
                        <!-- Answer options  -->
                        @if (question.answerOptions?.length) {
                          <div class="answers-wr">
                            <p class="text-xs font-semibold uppercase tracking-wide mb-2">{{ 'SURVEYS_SINGLE_VIEW.ANSWER_OPTIONS' | translate }}</p>
                            <div class="flex flex-col gap-3">
                              @for (answer of question.answerOptions; track answer) {
                                <div class="rounded-md border px-3 py-2">
                                  <span class="inline-block text-xs font-semibold mb-1.5">{{ answer.code | defaultValue }}</span>
                                  @for (translation of answer.answerTranslations; track translation; let isLast = $last) {
                                    <div class="flex items-start gap-2 py-1" [class.border-b]="!isLast">
                                      <span class="inline-flex items-center px-1.5 py-0.5 rounded text-xs font-semibold shrink-0 mt-0.5">
                                        {{ translation.isoCode | languagePipe }}
                                      </span>
                                      <span class="text-sm">{{ translation.translatedAnswer | defaultValue }}</span>
                                    </div>
                                  }
                                </div>
                              }
                            </div>
                          </div>
                        }
                      </div>
                    </div>
                  }
                </div>
              </section>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Confirmation: state change -->
<p-confirmDialog key="confirm-state-change-dialog" (onHide)="stateInitialValue = survey?.isActive">
  <ng-template pTemplate="header">
    <span class="p-dialog-title">{{ 'MODALBOXES.TITLE_CONFIRM_STATE_CHANGE' | translate }}</span>
  </ng-template>

  <ng-template pTemplate="message">
    <div class="flex flex-column align-items-center w-full gap-3">
      <p [innerHTML]="sanitizedConfirmMessage"></p>
    </div>
  </ng-template>

  <ng-template pTemplate="footer">
    <button id="btn-cancel-change" type="button" class="btn outline-btn" (click)="onCancelStateChange()">
      {{ 'MODALBOXES.BTN_CANCEL_STATE_UPDATE' | translate }}
    </button>
    <button id="btn-confirm-update" type="button" class="btn primary-btn" (click)="onConfirmStateChange()">
      {{ 'MODALBOXES.BTN_CONFIRM_STATE_UPDATE' | translate }}
    </button>
  </ng-template>
</p-confirmDialog>

<!-- Delete survey -->
<dialog-reason #dialog [title]="'MODALBOXES.TITLE_CONFIRM_DELETE_ITEM'" (onClose)="onDelete($event)"></dialog-reason>
